import React from 'react'
import styled from 'styled-components'

interface StatusIndicatorProps {
  statusColor: string
  status: string
  statusIcon?: string
  statusIconColor?: string
}


const StatusIndicator: React.FC<StatusIndicatorProps> = ({
  statusColor,
  status,
  statusIcon,
  statusIconColor,
}) => {
  return (
    <Wrapper>
      <Circle statusColor={statusColor} $hasIcon={Boolean(statusIcon)}>
        {statusIcon && (
          <Icon className={statusIcon} statusIconColor={statusIconColor} />
        )}
      </Circle>
      {status}
    </Wrapper>
  )
}

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 3px;
`

const Circle = styled.span<{ statusColor: string; $hasIcon: boolean }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 12px;
  min-height: 12px;
  width: ${({ $hasIcon }: { $hasIcon: boolean }) =>
    $hasIcon ? '16px' : '12px'};
  height: ${({ $hasIcon }: { $hasIcon: boolean }) =>
    $hasIcon ? '16px' : '12px'};
  border-radius: 50%;
  background-color: ${({ statusColor }: { statusColor: string }) => statusColor};
  flex-shrink: 0;
`

const Icon = styled.i<{ statusIconColor?: string }>`
  font-size: 8px;
  color: ${({ statusIconColor }: { statusIconColor?: string }) =>
    statusIconColor ?? 'inherit'};
`

export default StatusIndicator
